/**
 * Classification Type ID Mapping
 * Maps frontend classification labels to database type IDs
 * Based on legacy database types table
 */

import type { ClientClassification } from '../types/visit-wizard'

export const CLASSIFICATION_TYPE_IDS: Record<ClientClassification, number> = {
  'Senior Citizen': 200,
  'PWD - Vision': 211,
  'PWD - Speech': 212,
  'PWD - Hearing': 213,
  'PWD - Physical Disability': 214,
  'Women': 221,
  'Pregnant Women': 222,
  'VAWC (RA 9262) Victim': 223,
  'Foreign National': 224,
  'Rural Poor': 225,
  'Urban Poor': 226,
  'Law Enforcer': 230,
  'OFW – Land-based': 231,
  'OFW – Sea-based': 232,
  'Former Rebel (FR) and Former Violent Extremist': 234,
  'Refugee/Evacuee': 235,
  'Tenant in Agrarian Case': 236,
  'Arrested for Terrorism (R.A. No. 11479)': 237,
  'Victim of Torture (R.A. No. 9745)': 238,
  'Victim of Trafficking (R.A. No. 9208)': 239,
  'Petitioner for Voluntary Rehabilitation (Drugs)': 240,
  'Taiwanese National': 241,
  'Child in Conflict with the Law': 250,
}

/**
 * Convert classification labels to type IDs
 */
export function mapClassificationsToTypeIds(
  classifications: ClientClassification[]
): number[] {
  return classifications.map((label) => CLASSIFICATION_TYPE_IDS[label])
}

/**
 * Reverse lookup: classification type ID -> human-readable label
 */
export const CLASSIFICATION_LABELS_BY_ID: Record<number, ClientClassification> = Object.fromEntries(
  (Object.entries(CLASSIFICATION_TYPE_IDS) as [ClientClassification, number][]).map(
    ([label, typeId]) => [typeId, label]
  )
) as Record<number, ClientClassification>

/**
 * Convert classification type IDs back to their labels, skipping unknown IDs
 */
export function mapTypeIdsToClassifications(typeIds: number[]): string[] {
  return typeIds
    .map((id) => CLASSIFICATION_LABELS_BY_ID[id])
    .filter((label): label is ClientClassification => Boolean(label))
}

// Visit-level classification decision (matches legacy status codes)
export const VISIT_DECISION_LABELS: Record<number, string> = {
  100: 'Assisted',
  101: 'Denied',
}
